const AccessAdmin = () =>
  <>
    You must be logged in with administrator privileges to manage users.
  </>

export default AccessAdmin
